// don't change key anymore
export enum QuickFilterLocationEnum {
  Dashboard = 'dashboard',
  Integration = 'integration',
  Model = 'model',
  ImportHistory = 'IMPORT_HISTORY',
  ExportHistory = 'AUTOMATION_HISTORY',
  ImportSchedule = 'IMPORT_SCHEDULE',
  ExportSchedule = 'AUTOMATION_SCHEDULE',
  ProductUpdate = 'PRODUCT_UPDATE',
  Function = 'FUNCTION',
  Export = 'AUTOMATION',
  Dag = 'DAG',
  DagOverview = 'DAG_OVERVIEW',
}
